document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".open-tableau-popup");
  if (!buttons.length) return;

  const modal = document.getElementById("tableau-modal");
  const overlay = document.getElementById("modal-overlay");
  const closeModalButton = document.getElementById("close-modal");
  const popupContainer = document.getElementById("popup-tableau-container");

  function openModal() {
    modal.classList.add("show");
    modal.style.display = "block";
    overlay.style.display = "block";
  }

  function closeModal() {
    modal.classList.remove("show");
    modal.style.display = "none";
    overlay.style.display = "none";
    popupContainer.innerHTML = "";
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const tableauUrl = button.getAttribute("data-url");
      const urlObj = new URL(tableauUrl);
      const tableauPath = urlObj.pathname.split("/views/")[1];

      popupContainer.innerHTML = "";

      const placeholderDiv = document.createElement("div");
      placeholderDiv.className = "tableauPlaceholder";
      placeholderDiv.style.width = "100%";
      placeholderDiv.style.height = "100%";

      const tableauObject = document.createElement("object");
      tableauObject.className = "tableauViz";
      tableauObject.style.width = "100%";
      tableauObject.style.height = "100%";
      tableauObject.innerHTML = `
        <param name="host_url" value="https%3A%2F%2Fpublic.tableau.com%2F" />
        <param name="path" value="views/${tableauPath}?:language=en-US&:embed=true" />
        <param name="toolbar" value="yes" />
      `;

      placeholderDiv.appendChild(tableauObject);
      popupContainer.appendChild(placeholderDiv);

      const scriptElement = document.createElement("script");
      scriptElement.src = "https://public.tableau.com/javascripts/api/viz_v1.js";
      popupContainer.appendChild(scriptElement);

      openModal();
    });
  });

  closeModalButton.addEventListener("click", closeModal);
  overlay.addEventListener("click", closeModal);
});